import $ from 'jquery';
import * as React from 'react';
import { memo } from 'react';
import { withRouter } from 'react-router-dom';

import Link from 'components/atoms/Link';
import { routes } from 'defs';
import i18n from 'helper/i18n';
import { delayed } from 'lib/Job';
import { WithRouterType } from 'types/withRouter';

export const DEFAULT_NOTIFICATION_INTERFERENCE_TIME = 3000;

type CardFavouriteNotificationProps = {
	textSwitch: boolean;
	visible: boolean;
} & WithRouterType;

export const UIStates = {
	invisible: '',
	visible: 'state-m-card__notice--visible',
};

export const FavoriteNotification = ({ visible = false, textSwitch, history }: CardFavouriteNotificationProps) => {
	const text = i18n(`react.impulsCoach.components.card.addToFavorites.${textSwitch ? 'added' : 'removed'}`);

	const renderCta = () => {
		return (
			<div className="m-card__notice-link">
				<Link
					onClick={() => {
						delayed(() => $('html').removeClass('state-l-html--disable-scroll'), 100);
						history.push(routes.favorites.indexRoute.href);
					}}
					title={i18n('react.impulsCoach.components.card.addToFavorites.added.cta')}
					iconRight="link-arrow"
				/>
			</div>
		);
	};

	return (
		<div className={`m-card__notice ${visible ? UIStates.visible : UIStates.invisible}`}>
			<span className="m-card__notice-text">{text}</span>
			{textSwitch && renderCta()}
		</div>
	);
};

FavoriteNotification.displayName = 'Card(FavoriteNotification)';

export default memo(withRouter(FavoriteNotification as any)) as any;
